import { Countries } from '@platform/client';
import { FormsInputDropdown } from '@platform/components';
import { Control, FieldError, FieldValues, Path, RegisterOptions } from 'react-hook-form';

type SingleCountrySelectionDropdownProps<FData extends FieldValues> = {
  control: Control<FData>;
  rules?: RegisterOptions<FData>;
  label: string;
  errors?: FieldError;
  name: Path<FData>;
};

export const SingleCountrySelectionDropdown = <FData extends FieldValues>(
  props: SingleCountrySelectionDropdownProps<FData>,
) => {
  const { control, label, errors, rules, name } = props;

  const countriesList = Countries.useGetCountries();

  const countryOptions =
    countriesList.isSuccess ?
      countriesList.data.map((country) => ({
        text: country.name,
        textValue: country.id.toString(),
      }))
    : [];

  return (
    <FormsInputDropdown
      control={control}
      name={name}
      rules={rules}
      label={label}
      placeholder='Start typing country name'
      items={countryOptions}
      type='default'
      error={errors}
    />
  );
};
